import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showArrow?: boolean;
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  showArrow = false,
  fullWidth = false,
  href,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-900';
  const variants = {
    primary: 'bg-brand-orange text-white hover:bg-brand-light focus:ring-brand-orange shadow-[0_0_20px_rgba(249,115,22,0.3)] hover:shadow-[0_0_30px_rgba(249,115,22,0.5)] hover:-translate-y-1',
    secondary: 'bg-white text-navy-900 hover:bg-gray-100 focus:ring-white',
    outline: 'border-2 border-brand-orange text-brand-orange hover:bg-brand-orange/10 focus:ring-brand-orange'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg md:text-xl',
    xl: 'px-10 py-5 text-xl md:text-2xl'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className}`;
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={combinedClassName} data-id="element-209">
        {children}
        {showArrow && <ArrowRightIcon className="ml-2 h-5 w-5 md:h-6 md:w-6" data-id="element-210" />}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-211">
      {children}
      {showArrow && <ArrowRightIcon className="ml-2 h-5 w-5 md:h-6 md:w-6" data-id="element-212" />}
    </button>;
}